/* istanbul ignore file - need to fix flakey tests */

interface ResetAction<T> {
  type: 'reset';
  payload: T[];
}

interface AddCategoryAction<T> {
  type: 'addCategory';
  newCategory: T;
}

interface UpdateNodeAction<T> {
  type: 'update';
  updatedNode: T;
}

interface DeleteNodeAction<T> {
  type: 'delete';
  nodeToDelete: T;
}

interface MoveNodeAction<T> {
  type: 'move';
  nodeToMove: T;
  targetNode: T;
}

export type Action<T> =
  | ResetAction<T>
  | AddCategoryAction<T>
  | UpdateNodeAction<T>
  | DeleteNodeAction<T>
  | MoveNodeAction<T>;

export function usePartsCategoriesReducer<T extends { PID: string; parent?: string }>() {
  const reducer = (state: T[], action: Action<T>) => {
    switch (action.type) {
      case 'reset': {
        return action.payload;
      }
      case 'addCategory': {
        return [action.newCategory, ...state];
      }
      case 'update': {
        return state.map((node) => (node.PID === action.updatedNode.PID ? action.updatedNode : node));
      }
      case 'delete': {
        return state.filter((node) => node.PID !== action.nodeToDelete.PID);
      }
      case 'move': {
        const stateWithoutNodeToMove = state.filter((node) => node.PID !== action.nodeToMove.PID);

        return [
          ...stateWithoutNodeToMove,
          {
            ...action.nodeToMove,
            parent: action.targetNode.PID,
          },
        ];
      }
      /* istanbul ignore next - should never happen */
      default: {
        const actionType = (action as any).type;
        throw Error(`Unknown action: ${actionType}`);
      }
    }
  };

  return reducer;
}
